const envvars = process.env;

export const environmentVariables = {
  apiUrl: envvars.REACT_APP_API_BACKEND,
  frntUrl:envvars.REACT_APP_FRNT_URL,
  crmDubaiApi:envvars.REACT_APP_API_CRM_DUBAI,
  homeLoc:envvars.REACT_APP_HOME_URL,
  httpProtocol:envvars.REACT_APP_HTTP_PROTOCOL,
};
